import React, { useEffect, useState, useMemo } from 'react';
import { Skeleton } from "@mui/material";
import Box from "@mui/material/Box";
import Card from '@mui/material/Card';

const Documentos = (params) => {
  const baseUrl = process.env.REACT_APP_API_URL || window.location.origin;
  const url = useMemo(() => `${baseUrl}/content/documentos`, [baseUrl]);
  const requestHeaders = useMemo(() => {
    const headers = new Headers();
    headers.append("X-Frontend-Client", "react-app");
    return headers;
  }, []);
  const [pages, setPages] = useState([]);
  const [isLoading, setLoading] = useState(true);
  
  useEffect(() => {

    const fetchData = () => {
      fetch(url, {
        method: 'GET',
        headers: requestHeaders
        })
        .then((response) => response.json())
        .then((result) => {
          setPages(result);
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
    }
    fetchData();
  }, [url, requestHeaders]);

  return (
    <div>
        {isLoading
          ?
            <Skeleton sx={{ bgcolor: 'rgba(255, 255, 255, 0.5)' }} variant="rectangular" width={210} height={25} animation="wave" className="skeleton_FE"/>
          :
            <Box className="transparencia_list">
            {Object.entries(pages).map(([key, value]) => (
              <Card className="transparencia_card" key={key}>
                <div className="balancete_item">
                  <p><a className='transparencia_link' href={`${baseUrl}/api${value.url}`}>{value.nome}</a></p>
                </div>
              </Card>
            ))}
          </Box>
        }
    </div>
  );
};

export default Documentos;

